import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Link from '../../components/common/Link';

import * as UsersActionCreators from '../../redux/users';
import * as UiActionsCreators from '../../redux/ui';

const CancelButton = styled.div`
  display: inline;
  margin-right: 30px;
`;

class UsersEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      password: ''
    };
  }

  async componentDidMount() {
    const {
      actions,
      match: { params }
    } = this.props;
    await actions.getUser(params.id);
    const { user } = this.props;
    this.setState({
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email
    });
  }

  onClickUpdate = async () => {
    const { actions, user, history } = this.props;
    const { first_name, last_name, email, password } = this.state;
    try {
      if (first_name && last_name) {
        const updateData = {
          first_name: first_name,
          last_name: last_name,
          email: email || null
        };
        if (password && password.length < 8) {
          return actions.showNotification({
            message: 'Minimum 8 char required for password',
            type: 'warning'
          });
        } else if (password && password.length >= 8) {
          await actions.updateUserPassword(user.id, {
            password: password
          });
        }

        await actions.updateUser(user.id, updateData);
        history.push('/users');
      } else {
        actions.showNotification({
          message: 'First name & last Name are compulsory fields',
          type: 'warning'
        });
      }
    } catch (e) {
      if (e.message === 'Request failed with status code 403') {
        actions.showNotification({
          message:
            'Another user account already exists with this email address.',
          type: 'error'
        });
      } else {
        actions.showNotification({
          message:
            'Something went wrong while updating this user, please try again.',
          type: 'error'
        });
      }
    }
  };
  onChangeInput(field, value) {
    this.setState({ [field]: value });
  }

  render() {
    const { user } = this.props;
    const { first_name, last_name, email, password } = this.state;
    if (!user) return null;
    return (
      <div>
        <h2>
          Edit {user.first_name} {user.last_name}
        </h2>
        <div>
          <TextField
            value={first_name}
            id="first_name"
            label="First Name *"
            type="text"
            margin="normal"
            onChange={e => this.onChangeInput('first_name', e.target.value)}
          />
        </div>
        <div>
          <TextField
            value={last_name}
            id="last_name"
            label="Last Name *"
            type="text"
            margin="normal"
            onChange={e => this.onChangeInput('last_name', e.target.value)}
          />
        </div>
        <div>
          <TextField
            value={email}
            id="email"
            label="Email"
            type="text"
            margin="normal"
            onChange={e => this.onChangeInput('email', e.target.value)}
          />
        </div>
        <div>
          <TextField
            value={password}
            id="password"
            label="Password"
            type="text"
            margin="normal"
            onChange={e => this.onChangeInput('password', e.target.value)}
          />
        </div>
        <div>
          <CancelButton>
            <Link to="/users">
              <Button variant="outlined" color="primary">
                CANCEL
              </Button>
            </Link>
          </CancelButton>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onClickUpdate}
          >
            Update
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.users.user
  };
};

const ActionCreators = Object.assign(
  {},
  UsersActionCreators,
  UiActionsCreators
);

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UsersEditPage)
);



// WEBPACK FOOTER //
// ./src/pages/users/edit.js